<!-- Zweck: Stellt die HTML-Struktur für shop view field value renderer component im Frontend bereit. -->
<ng-container [ngTemplateOutlet]="
fieldname=='bezeichnung'?template_bezeichnung:
fieldname=='minablauf'?template_minablauf:
fieldname== 'darreichungsform'?template_darreichungsform:
fieldname=='Zulassungsnummer'?template_Zulassungsnummer:
fieldname=='hersteller'?template_hersteller:
fieldname=='artikelnummer'?template_artikelnummer:
fieldname=='pzn'?template_pzn:
fieldname=='einkaufspreis'?template_einkaufspreis:
fieldname=='verkaufspreis'?template_verkaufspreis:
fieldname=='kassapreis'?template_kassapreis:
fieldname=='mwst'?template_mwst:
fieldname=='rezeptzeichen'?template_rezeptzeichen:
fieldname=='istarzneimittel'?template_istarzneimittel:
fieldname=='status'?template_status:
fieldname=='aktionen_button'?template_aktionen_button:
fieldname=='einkaufs_statistik_web_button'?template_einkaufs_statistik_web_button:
fieldname=='aktionen_first_stage'?template_aktionen_first_stage:
fieldname=='aktionen_second_stage'?template_aktionen_second_stage:
fieldname=='aktionen_third_stage'?template_aktionen_third_stage:
fieldname=='logo1'?template_logo1:
fieldname=='logo2'?template_logo2:
fieldname=='Beschreibung'?template_Beschreibung:
fieldname=='boxerstattungskodex'?template_BoxErstattungskodex:
fieldname=='avp'?template_avp:
fieldname=='Breite'?template_Breite:
fieldname=='Laenge'?template_Laenge:
fieldname=='Hoehe'?template_Hoehe:
fieldname=='Gewicht'?template_Gewicht:
fieldname=='view'?template_view:
fieldname=='Kurzbeschreibung'?template_Kurzbeschreibung:
fieldname=='note'?template_note:
template_default
"
></ng-container>
<ng-template #template_bezeichnung>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    <span>{{ artikel.label }}</span>
    <article-dtp-icon [isDtp]="artikel.IstDtpArtikel"></article-dtp-icon>
    @if ((wksvc.artnr_wk_map2$|async)?.includes(artikel.ArtikelNummer.toString()) && isInOtherWarenkorb()) {
      <span
        style="padding-left: 5px;">
        <svg-icon matTooltip="Bereits in einem Warenkorb" [size]="14"
        style="color: green; height: 14px; width: 14px; font-size: 14px">warenkorb</svg-icon>
      </span>
    }
  </span>
</ng-template>


<ng-template #template_minablauf>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    {{ artikel.MinAblauf }}
  </span>
</ng-template>

<ng-template #template_darreichungsform>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    {{ artikel.Darreichungsform }}
  </span>
</ng-template>

<ng-template #template_Zulassungsnummer>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    {{ artikel.ArtikelZulassungsnummer|RemoveLeadingZero }}
  </span>
</ng-template>

<ng-template #template_logo1>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    @if (mode == 'table') {
      <lightbox-image [image]="artikel.logo1" [thumb_max_height]="50"></lightbox-image>
    }
    @if (mode != 'table') {
      <lightbox-image [image]="artikel.logo1" [thumb_max_height]="250"></lightbox-image>
    }
  </span>
</ng-template>

<ng-template #template_logo2>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    @if (mode == 'table') {
      <lightbox-image [image]="artikel.logo2" [thumb_max_height]="50"></lightbox-image>
    }
    @if (mode != 'table') {
      <lightbox-image [image]="artikel.logo2" [thumb_max_height]="250"></lightbox-image>
    }
  </span>
</ng-template>

<ng-template #template_pzn>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    @if (artikel.PZN) {
      <span>
        {{ artikel.PZN|PhZNr }}{{ append_if_not_empty }}
      </span>
    }
  </span>
</ng-template>

<ng-template #template_avp>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    {{ artikel.Kundenverkaufspreis|NiceNumber }}@if (artikel.Kundenverkaufspreis !== null) {
    &euro;
  }
</span>
</ng-template>

<ng-template #template_verkaufspreis>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    {{ artikel.Kundenverkaufspreis|NiceNumber }}@if (artikel.Kundenverkaufspreis !== null) {
    &euro;
  }
</span>
</ng-template>

<ng-template #template_kassapreis>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
        [style.white-space]="nowrap ? 'nowrap': ''">
    {{ artikel.KPR|NiceNumber }}@if (artikel.KPR !== null) {
    &euro;
  }
</span>
</ng-template>

<ng-template #template_view>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">

    @if (artikel.view.settings && artikel.view.settings.label) {
      {{ artikel.view.settings.label }}
    } @else {
      {{ artikel.view.label }}
    }
  </span>
</ng-template>

<ng-template #template_mwst>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    {{ artikel.Mehrwertsteuersatz }} %
  </span>
</ng-template>

<ng-template #template_einkaufspreis>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    @if ((show_uvp|async)) {
      @if (artikel.UVPDiffProzent > 0) {
        <table>
          <tr style="background-color: transparent">
            <td rowspan="2" style="vertical-align: middle; border: 0; padding: 5px; padding-left: 20px">
              <span style="font-size: 18px; color: orange; font-weight: bold;">
                {{ artikel.Kundeneinkaufspreis|NiceNumber }}@if (artikel.Kundeneinkaufspreis !== null) {
                &euro;
              }
            </span>
          </td>
          <td style="border: 0; padding: 0">
            <div class="line-through" style="font-size: 16px; color: grey">
              {{ artikel.PreisLtPreiscodeMitPotentiellAufschlag|NiceNumber }}@if (artikel.PreisLtPreiscodeMitPotentiellAufschlag !== null) {
              &euro;
            }
          </div>
        </td>
      </tr>
      <tr style="background-color: transparent">
        <td style="border: 0; padding: 0; text-align: right">
          <div class="uvpdiffbox">
            -{{ artikel.UVPDiffProzent }} %
          </div>
        </td>
      </tr>
    </table>
  } @else {
    {{ artikel.Kundeneinkaufspreis|NiceNumber }}@if (artikel.Kundeneinkaufspreis !== null) {
    &euro;
  }
}
} @else {
  {{ artikel.Kundeneinkaufspreis|NiceNumber }}@if (artikel.Kundeneinkaufspreis !== null) {
  &euro;
}
}
</span>
</ng-template>

<ng-template #template_rezeptzeichen>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    {{ artikel.RezeptZeichen }}
  </span>
</ng-template>

<ng-template #template_istarzneimittel>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    @if (artikel.IstArzneimittel) {
      <span matTooltip="Ist ein Arzneimittel">
        <svg-icon>success</svg-icon>
      </span>
    }
  </span>
</ng-template>

<ng-template #template_status>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    <artikel-status-icon [artikel]="artikel"></artikel-status-icon>
  </span>
</ng-template>



<ng-template #template_aktionen_button>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    @if (view && artikel?.ArtikelHatAktion && cfg.showShopAktionen(artikel) && !cfg.domainconfig?.shop_aktionen_popup) {
      <artikel-aktionen-button
        [artikel]="artikel"
        [view]="view"
        [viewcomp]="viewcomp"
      ></artikel-aktionen-button>
    }
  </span>
</ng-template>

<ng-template #template_einkaufs_statistik_web_button>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
        [style.white-space]="nowrap ? 'nowrap': ''">
    @if (view && artikel && artikel.EinkaufsStatistikWeb) {
      <einkaufs-statistik-web-button
        [artikel]="artikel"
        [view]="view"
        [viewcomp]="viewcomp"
      ></einkaufs-statistik-web-button>
    }
  </span>
</ng-template>

<ng-template #template_aktionen_first_stage>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
        [style.white-space]="nowrap ? 'nowrap': ''">
    @if (view && artikel?.ArtikelHatAktion && cfg.showShopAktionen(artikel) && !cfg.domainconfig?.shop_aktionen_popup) {
    <artikel-aktionen-stage
      [artikel]="artikel"
      [view]="view"
      [viewcomp]="viewcomp"
      [stage]="1"
    ></artikel-aktionen-stage>
  }
  </span>
</ng-template>

<ng-template #template_aktionen_second_stage>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
        [style.white-space]="nowrap ? 'nowrap': ''">
    @if (view && artikel?.ArtikelHatAktion && cfg.showShopAktionen(artikel) && !cfg.domainconfig?.shop_aktionen_popup) {
      <artikel-aktionen-stage
        [artikel]="artikel"
        [view]="view"
        [viewcomp]="viewcomp"
        [stage]="2"
      ></artikel-aktionen-stage>
    }
  </span>
</ng-template>

<ng-template #template_aktionen_third_stage>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
        [style.white-space]="nowrap ? 'nowrap': ''">
    @if (view && artikel?.ArtikelHatAktion && cfg.showShopAktionen(artikel) && !cfg.domainconfig?.shop_aktionen_popup) {
      <artikel-aktionen-stage
        [artikel]="artikel"
        [view]="view"
        [viewcomp]="viewcomp"
        [stage]="3"
      ></artikel-aktionen-stage>
    }
  </span>
</ng-template>

<ng-template #template_hersteller>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    {{ artikel.Erzeuger.adresszeile1 }}
  </span>
</ng-template>

<ng-template #template_note>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}" style="vertical-align: middle"
    [style.white-space]="nowrap ? 'nowrap': ''">
    <artikel-note [artikel]="artikel"></artikel-note>
  </span>
</ng-template>

<ng-template #template_Laenge>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    {{ artikel[fieldname]|unitconverter_mm }}
  </span>
</ng-template>

<ng-template #template_Breite>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    {{ artikel[fieldname]|unitconverter_mm }}
  </span>
</ng-template>

<ng-template #template_Hoehe>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    {{ artikel[fieldname]|unitconverter_mm }}
  </span>
</ng-template>

<ng-template #template_Gewicht>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    {{ artikel[fieldname]|unitconverter_g }}
  </span>
</ng-template>

<ng-template #template_artikelnummer>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    {{ artikel['ArtikelNummer'] }}
  </span>
</ng-template>

<ng-template #template_Kurzbeschreibung>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    <span [innerHTML]="artikel['Kurzbeschreibung']|nl2br"></span>
  </span>
</ng-template>

<ng-template #template_Beschreibung>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    <span [innerHTML]="artikel['Beschreibung']|nl2br"></span>
  </span>
</ng-template>


<ng-template #template_BoxErstattungskodex>
  <span class="field_{{fieldname}}" [style.white-space]="nowrap ? 'nowrap': ''" [matTooltip]="(tooltip|async) ? (tooltip|async) : null">
    <div class="boxerstattungskodex boxerstattungskodex_{{artikel['BoxErstattungskodex']}}">
      {{artikel['BoxErstattungskodex']}}
    </div>
  </span>
</ng-template>



<ng-template #template_default>
  <span [class.sgarticle]="artikel.RezeptZeichen == 'SG'" class="field_{{fieldname}}"
    [style.white-space]="nowrap ? 'nowrap': ''">
    @if (artikel[fieldname]) {
      <span>{{ artikel[fieldname] }}</span>
      @if (fieldname == 'ArtikelName' || fieldname == 'ArtikelBezeichnung') {
        <article-dtp-icon [isDtp]="artikel.IstDtpArtikel"></article-dtp-icon>
      }
    }
    @if (artikel[fieldname] === undefined) {
      <span>missing {{ fieldname }}</span>
    }
  </span>
</ng-template>
